/**
 * @param {string} input - The input to uppercase
 * @returns {string} - Uppercased input
 */
export default function uppercase(input) {
	if (typeof input !== 'string') { throw new TypeError('Value is not a string') }
	return input.toLocaleUpperCase()
}
